import React from "react";
import { Message } from "components/generic/layout";
import { Overlay } from "components/common/candidate";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { colors } from "core/stylesheet";
import * as hoc from "modules/user/auth/hoc";
import { compose } from "recompose";
import { isOnboardedCandidate } from "modules/user/auth/model";

const StyledLink = styled(Link)`
  color: ${colors.brand};
  text-decoration: none;
  font-weight: bold;
`;

export default compose(hoc.authorized(isOnboardedCandidate))(() => (
  <Overlay>
    <Message
      title="Payment successful!"
      text="You'll receive a confirmation of your request and a calendar invite once the insider has agreed to the time slot you've proposed."
      showIcon
      subtext={
        <span>
          Give your friend $20 off on their first call by inviting them<StyledLink to="/user/invite">
            {" "}
            here
          </StyledLink>
        </span>
      }
    />
  </Overlay>
));



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/PaymentSuccess/index.js